import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogOut, LayoutDashboard, Heart } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = ["For Individuals", "For Employers", "For Hospitals & Health Systems", "Features"];

export default function Navbar({ onOpenLogin }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-9 inset-x-0 z-50 transition-colors duration-300 ${scrolled ? "bg-white/80 backdrop-blur-xl border-b border-slate-200" : "bg-transparent"}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <button data-testid="logo-btn" onClick={() => navigate("/")} className="flex items-center gap-2">
          <Logo className="h-9" showTagline />
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a key={n} href="#services" data-testid={`nav-${n.split(" ")[1]?.toLowerCase() || "features"}`}
              className="text-sm font-medium text-slate-600 hover:text-[#041E26] transition-colors">{n}</a>
          ))}
          <button data-testid="nav-eldercare" onClick={() => navigate("/eldercare")}
            className="text-sm font-semibold text-[#D97706] hover:text-[#92400E] transition-colors flex items-center gap-1">
            <Heart className="w-3.5 h-3.5" /> Eldercare
          </button>
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Button data-testid="nav-dashboard-btn" onClick={() => navigate("/dashboard")} variant="ghost"
                className="rounded-full text-[#041E26] hidden sm:flex gap-2"><LayoutDashboard className="w-4 h-4" /> Dashboard</Button>
              <Button data-testid="nav-logout-btn" onClick={() => { logout(); navigate("/"); }} variant="outline"
                className="rounded-full gap-2"><LogOut className="w-4 h-4" /> Sign out</Button>
            </>
          ) : (
            <Button data-testid="nav-login-btn" onClick={onOpenLogin}
              className="rounded-full bg-[#041E26] hover:bg-[#0A2F3C] text-white font-semibold px-5 h-10">
              Sign In / Portal Access
            </Button>
          )}
        </div>
      </div>
    </motion.header>
  );
}
